import React from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';

import styles from './QuantityCheckDetails.module.scss';
import { DecimalInput } from '@/components/DecimalInput';


export const QuantityCheckDetails: React.FC<DynamicComponentProps> = ({ inspection, onValueChange }: DynamicComponentProps) => {
  const { t: translate } = useTranslation();

  const handleDecimalChange = (event: { target: { name: string; value: number | null } }) => {
    if (onValueChange) {
      onValueChange(event as any);
    }
  };

  return (
    <div className={styles.formContainer}>
      <div className={styles.inputRow}>
        <div className={styles.inputGroup}>

          <DecimalInput
            id="lotSize"
            name="lotSize"
            value={inspection?.lotSize}
            onChange={handleDecimalChange}
            label={translate('Advised Quantity')}
            labelClassName={styles.label}
            className={styles.input}
            
          />
        </div>
        <div className={styles.inputGroup}>
          <label className={styles.label} htmlFor="actualQuantity">{translate('Actual Quantity')}</label>
          <input className={styles.input} type="number" id="actualQuantity" name="actualQuantity" onChange={onValueChange} value={inspection?.actualQuantity} />
        </div>
      </div>
    </div>
  )
}
